import axios, { AxiosResponse } from 'axios';
import { PriceRequest, PriceRequestProduct, PriceRequestProductsLookup, RequestPriceResponse } from '@/models/PriceRequest';
import { CheckoutCountryModel } from '@/models/Checkout';

export default class PriceRequestService {
    private profileId: string = (window as any).CbxApiContextKey;
    private endpoint: string;

    constructor(args: any = {}) {
        if (args.profileId)
            this.profileId = args.profileId;
        this.endpoint = `/contextapi/${this.profileId}/v1/pricingrequest`;
    }

    public getRequestProductsModel(args: any = {}): PriceRequest {
        return {
            products: args.products,
            count: 0
        };
    }

    public getPriceRequestLookupModel(args: any = {}): PriceRequestProductsLookup {
        return args;
    }

    public createLookup(requests: PriceRequest): PriceRequestProductsLookup {
        return requests?.products.reduce((output: PriceRequestProductsLookup, item: PriceRequestProduct) => {
            output[`${item.id}`] = item;
            return output;
        }, {});
    }

    public async getPriceRequestProducts(): Promise<PriceRequest> {
        try {
            const res: AxiosResponse<PriceRequest> = await axios.get(`${this.endpoint}/getpricerequests`)
            return res.data;
        } catch (e) {
            console.log(e);
        }
    }

    public async addRequestProduct(args: any): Promise<PriceRequest> {
        try {
            const res: AxiosResponse<PriceRequest> = await axios.post(`${this.endpoint}/addrequestproduct`, args);
            return res.data;
        } catch (e) {
            console.log(e);
        }
    }

    public async removeRequestProduct(args: any): Promise<PriceRequest> {
        try {
            const res: AxiosResponse<PriceRequest> = await axios.post(`${this.endpoint}/removerequestproduct`, args);
            return res.data;
        } catch (e) {
            console.log(e);
        }
    }

    public async sendRequest(args: any): Promise<RequestPriceResponse> {
        try {
            const res: AxiosResponse<RequestPriceResponse> = await axios.post(`${this.endpoint}/sendrequest`, args);
            return res.data;
        } catch (e) {
            console.log(e)
        }
    }

    public async getCountries(): Promise<CheckoutCountryModel[]> {
        try {
            const res: AxiosResponse<any> = await axios.get(`${this.endpoint}/getcountries`);
            return res.data;
        } catch (e) {
            console.log(e);
        }
    }
}